import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN REKOM ADMIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/main/MainRekomAdmin.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'admin-home',
          component: () => import('./views/admin/dashboard/Dashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },
        
        {
          path: '/users',
          name: 'admin-users',
          component: () => import('./views/admin/users/UserList.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/users/register',
          name: 'admin-register-user',
          component: () => import('./views/admin/users/RegisterUser.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/users/sync',
          name: 'admin-sync-planday-users',
          component: () => import('./views/admin/users/SyncPlandayUsers.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/users/:userId',
          name: 'admin-user',
          component: () => import('./views/admin/users/user/User.vue'),
          meta: { 
            requiresAuth: true
          }
        },

        {
          path: '/venues',
          name: 'admin-venues',
          component: () => import('./views/admin/venues/VenueList.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/venues/:venueId',
          name: 'venue-home',
          component: () => import('./views/admin/venues/venue/Venue.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        /*
        {
          path: '/venues/register',
          name: 'admin-register-venue',
          component: () => import('./views/admin/venues/RegisterVenue.vue'),
          meta: { 
            requiresAuth: true
          }
        },*/
        {
          path: '/venues/sync',
          name: 'admin-sync-planday-venues',
          component: () => import('./views/admin/venues/SyncPlandayVenues.vue'),
          meta: { 
            requiresAuth: true
          }
        },

        {
          path: '/planday',
          name: 'admin-planday',
          component: () => import('./views/admin/planday/Planday.vue'),
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/planday/:portalId',
          name: 'admin-planday-portal',
          component: () => import('./views/admin/planday/portal/Portal.vue'),
          meta: { 
            requiresAuth: true
          }
        },
      ],
    },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/auth-redirect',
          name: 'auth-redirect',
          component: () => import('@/views/pages/AuthRedirect.vue')
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/AutoLogin.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.beforeResolve((to, from, next) => {
  console.log("To and from:");
  console.log(to);
  console.log(from);

  // No auth required
  if (!to.matched.some(record => record.meta.requiresAuth)) {
      next();
      return;
  }

  // Authenticated
  var accessToken = localStorage.getItem('rekom.idm.accessToken');
  if (accessToken !== null /*&& router.app.$msal.isAuthenticated() === true*/) {
      next()
      return
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
